import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { defaultJsonRequestHeaders, logError } from './api';
import { getLanguage } from 'tradera/utils/language';
import { toLocalizedUrl } from 'tradera/utils/url';

const isUnauthorized = (response) =>
    response.error && response.error.status === 401;

const isMissingAuthToken = (response) => {
    return (
        response.error &&
        response.error.status === 400 &&
        response.error.data.responseStatus.errorCode === 'MissingAuthToken'
    );
};

const baseQuery = fetchBaseQuery({
    baseUrl: '',
    prepareHeaders: (headers) => {
        Object.keys(defaultJsonRequestHeaders).forEach((headerName) => {
            headers.set(headerName, defaultJsonRequestHeaders[headerName]);
        });
        return headers;
    },
    credentials: 'include'
});

export const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (isMissingAuthToken(result) || isUnauthorized(result)) {
        // try to get a new token
        const refreshResult = await baseQuery(
            toLocalizedUrl('/login/state', getLanguage()),
            api,
            extraOptions
        );
        if (refreshResult.data) {
            // retry the initial query
            result = await baseQuery(args, api, extraOptions);
            if (isUnauthorized(result)) {
                logError(result);
            }
        } else {
            logError(result);
            window.location.reload();
        }
    }
    return result;
};
